import { PrimaryNavigation } from './PrimaryNavigation';
import { ServiceNavigation, ServiceNavigationBehaviours } from './ServiceNavigation';
import { Accordion, AccordionTabs, TabPanel } from './MultiPanelElements';
import { SearchModal } from './Modal';
import { suggestionAutoComplete } from './Search';
import { MenuToggleButton, ToggleButton } from './ToggleButton';
import callbackService from './CallBackService';

const forAll = (selector, fn) => Array.from(document.querySelectorAll(selector)).forEach(fn);

const components = {
    serviceNavigation: {
        init: function() {
            const serviceNavigation = new ServiceNavigation();
            serviceNavigation.element = document.querySelector('.services-panel');
            const serviceNavigationScrollBehaviour = new ServiceNavigationBehaviours.expandTop();
            serviceNavigationScrollBehaviour.callback = serviceNavigation.toggleExtended;
            serviceNavigation.behaviour = serviceNavigationScrollBehaviour;
        },
    },
    primaryNavigation: {
        init: function () {
            new PrimaryNavigation(document.querySelector('.js-megamenu-on-desktop'));
        }
    },
    accordion: {
        init: function () {
            forAll('.js-accordion', e => new Accordion(e, 'accordion'));
        }
    },
    tabPanel: {
        init: function () {
            forAll('.js-tabs', e => new TabPanel(e, 'tabs'));
        }
    },
    accordionTabs: {
        init: function() {
            forAll('.js-accordion-tabs', e => new AccordionTabs(e, 1024, 'accordion', 'tabs'));
        }
    },
    searchModal: {
        init: function () {
            window.searchModal = new SearchModal();
        }
    },
    searchSuggestions: {
        init: function () {
            forAll('.js-solr-q', e => suggestionAutoComplete(e));
        }
    },
    toggleButton: {
        init: function () {
            forAll('.js-toggle', e => new ToggleButton(e));
            forAll('.js-menu-toggle', e => new MenuToggleButton(e));
        }
    },
    callbackService: callbackService,
};


export {
    components,
};
